import { requirePermission } from '@/utils/auth'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import PageShell from '@/components/Common/PageShell'
import ErrorState from '@/components/Common/ErrorState'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/drive-details')({
  beforeLoad: () => requirePermission('drive_management'),
  component: DriveDetailsLayoutComponent,
})

function DriveDetailsLayoutComponent() {
  const location = useLocation()
  const { t } = useTranslation('driveDetails')

  const isExactPath = location.pathname === '/drive-details' || location.pathname === '/drive-details/'

  if (isExactPath) {
    return (
      <PageShell title={t('driveDetails')}>
        <ErrorState title={t('driveIdRequired')} message={t('driveIdRequiredMessage')} />
      </PageShell>
    )
  }

  return <Outlet />
}
